import { MuiThemeProvider as MuiThemeProviderLatest } from '../Subscription/util'
import muiTheme from '../../assets/mui-theme'
import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider'
import OfflineDialog from '../../components/OfflineDialog'
import React from 'react'
import styles from '../../styles.css'
import { StylesProvider, createGenerateClassName } from '@material-ui/styles'

// NOTE: Since we use a non-standard setup for MUI (multiple versions), we need to be careful about how we determine classNames. Without this setup, styles go wonky when building for production.

/** Function to generate classNames */
const generateClassName = createGenerateClassName({
  productionPrefix: 'rach-',
  disableGlobal: true
})

/**
 * Main `app` setup/container
 * @property {object} props - Component properties
 * @property {object} state - Component state
 */
export default class App extends React.Component {
  /**
   * @constructor
   * @param {object} props - Component properties
   */
  constructor(props) {
    super(props)
    this.props = props
    this.state = {
      dialogOpen: false
    }
  }

  /** Attach online/offline listeners */
  componentDidMount() {
    const _this = this

    window.addEventListener('offline', function() {
      _this.setState({
        dialogOpen: true
      })
    })

    window.addEventListener('online', function() {
      _this.setState({
        dialogOpen: false
      })
      location.reload()
    })
  }

  /** Reload browser */
  handleAction() {
    location.reload()
  }

  /**
   * Render Component
   * @returns {JSX} - Component
   */
  render() {
    return (
      <section className={styles.screen}>
        <StylesProvider generateClassName={generateClassName}>
          <MuiThemeProviderLatest>
            <MuiThemeProvider muiTheme={muiTheme}>
              <div>{this.props.children}</div>
            </MuiThemeProvider>
          </MuiThemeProviderLatest>
          <OfflineDialog
            onClick={this.handleAction}
            open={this.state.dialogOpen}
          />
        </StylesProvider>
      </section>
    )
  }
}
